import React, { useState } from "react";
import { showFindYourDoctorSection } from "../../../../utils/feattureFlag";

import * as S from "./styles";

type LinkSection = {
  name: string;
  url: string;
  page: string;
};

const HOME_SECTION = {
  name: "Home",
  url: "/",
  page: "PAGES.HOME.id",
};
const FIND_YOUR_DOCTOR_SECTION = {
  name: "Encontre seu médico",
  url: "/#encontre-seu-medico",
  page: "PAGES.HOME.id",
};
const APS_SECTION = {
  name: "Equipe de cuidado",
  url: "/#equipe-de-cuidado",
  page: "PAGES.HOME.id",
};
const VACCINE_SECTION = {
  name: "Imunização",
  url: "/#imunizacao",
  page: "PAGES.HOME.id",
};
const UNITS_SECTION = {
  name: "Unidades",
  url: "/#unidades",
  page: "PAGES.HOME.id",
};

type ListLinksProps = {
  onCloseNav: () => void;
};

const ListLinks = ({ onCloseNav }: ListLinksProps) => {
  const [active, setActive] = useState(0);
  const [links, setLinks] = useState<LinkSection[]>([]);

  React.useEffect(() => {
    const menuLinks: LinkSection[] = [];
    menuLinks.push(HOME_SECTION);
    if (showFindYourDoctorSection()) menuLinks.push(FIND_YOUR_DOCTOR_SECTION);
    menuLinks.push(APS_SECTION);
    menuLinks.push(VACCINE_SECTION);
    menuLinks.push(UNITS_SECTION);
    setLinks(menuLinks);

    const hrefLink = window.location.href.split("#")[1];

    const activeLink = menuLinks.findIndex(
      (item) => item.url === `/#${hrefLink}`
    );

    if (activeLink !== -1) window.location.href = `/#${hrefLink}`

    setActive(activeLink);
  }, []);

  return (
    <S.List>
      {links.map((link, _index) => {
        return (
          <S.Link
            key={_index}
            onClick={() => {
              window.location.href = link.url;
              console.log(window.location.href, link.url);

              onCloseNav();
              setActive(_index);
            }}
            active={active === _index}
          >
            <p>{link.name}</p>
          </S.Link>
        );
      })}
    </S.List>
  );
};

export default ListLinks;
